import { noPayloadEventSource, fetchClient } from '@openpeepshq/fetch-client';
import { admin } from './endpoints/admin.js';
import { analytics } from './endpoints/analytics.js';
import { i18n } from './endpoints/i18n.js';
import { accounts } from './endpoints/accounts.js';
import { jams } from './endpoints/jams.js';
import { auth } from './endpoints/auth.js';
import { conversations } from './endpoints/conversations.js';
import { groups } from './endpoints/groups.js';
import { posts } from './endpoints/posts.js';
import { plugins } from './endpoints/plugins.js';
import { server } from './endpoints/server.js';
import { profiles } from './endpoints/profiles.js';
import { sso } from './endpoints/sso.js';
import { location } from './endpoints/location.js';
import { reports } from './endpoints/reports.js';
import { media } from './endpoints/media.js';
import { search } from './endpoints/search.js';
import { previewLink } from './endpoints/previewLink.js';
import { payments } from './endpoints/payments.js';
import { streaming } from './endpoints/streaming.js';
import { webhookHandler } from './webhooks/index.js';
const allPeepClientOptionsToClientConfig = (options) => {
    var _a;
    return ({
        baseUrl: ((_a = options === null || options === void 0 ? void 0 : options.baseUrl) !== null && _a !== void 0 ? _a : '') + '/api/openpeeps/core/v1',
        headers: (options === null || options === void 0 ? void 0 : options.token)
            ? {
                Authorization: `Bearer ${options.token}`,
            }
            : undefined,
    });
};
export const openpeepsClient = (options) => {
    const config = typeof options === 'function'
        ? async () => allPeepClientOptionsToClientConfig(await options())
        : allPeepClientOptionsToClientConfig(options);
    const rawClient = fetchClient(config);
    const allPeepNoPayloadEventSource = noPayloadEventSource(config);
    const serverEndpoints = server(rawClient);
    return {
        admin: admin(rawClient),
        analytics: analytics(rawClient),
        accounts: accounts(rawClient),
        auth: auth(rawClient),
        conversations: conversations(rawClient),
        groups: groups(rawClient),
        i18n: i18n(rawClient),
        jams: jams(rawClient, allPeepNoPayloadEventSource),
        mediaAttachment: media(rawClient, allPeepNoPayloadEventSource),
        plugins: plugins(rawClient),
        posts: posts(rawClient),
        previewLink: previewLink(rawClient),
        profiles: profiles(rawClient, allPeepNoPayloadEventSource),
        server: serverEndpoints,
        sso: sso(rawClient),
        location: location(rawClient),
        reports: reports(rawClient),
        search: search(rawClient),
        payments: payments(rawClient),
        streaming: streaming(rawClient),
        webhookHandler: webhookHandler(serverEndpoints.keys.webhooks.public),
    };
};
